import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, scoreUp, currentPage, set_ep1_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import { quest3Data, quest3Selected } from '../../../Redux/Slices/selectedOptionSlice';
import './F12.css';
import backIcon from '../../../Assests/backIcon.svg';
import wrongIcon from '../../../Assests/wrongIcon.svg';
import trueIcon from '../../../Assests/trueIcon.svg';

function Frame12() {
    let [isLoading, setIsLoading] = useState(false);
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);
    let quest3 = useSelector(quest3Data);
    useEffect(() => {
        dispatch(scoreUp({index:2, answer: false}));
        setTimeout(function () { setIsLoading(false) }, 100);

    }, []);


    if (isLoading === true) {
        return (<div className="F11_image"></div>)
    } else {
        return (
            <div>
                <div className="F12_imageAnimate">
                    <div className="F12_entryBox">
                        <div className="F12_heading">
                            {language === 'english' ?
                                <p className="F12_headingEnglish">Should Saira be ashamed of her periods?</p>
                                :
                                <p className="F12_headingUrdu">کیا سائرا کو اپنی ماہواری کے بارے میں شرمندہ ہونا چاہیئے؟</p>
                            }
                        </div>
                        <div className="F12_options">
                            <div /*onClick={()=>{dispatch(frame5Selected('A'),  dispatch(pageUp()))}}*/ className={language === 'english' ? "F12_option" : "F12_optionUrdu"}>
                                {language === 'english' ? `A. ${quest3.headingEnglish.A}` : `${quest3.headingUrdu.A}`}
                            </div>

                            <div /*onClick={()=>{dispatch(frame5Selected('B'),  dispatch(pageUp()))}}*/ className={language === 'english' ? "F12_option" : "F12_optionUrdu"}>
                                {language === 'english' ? `B. ${quest3.headingEnglish.B}` : `${quest3.headingUrdu.B}`}
                            </div>
                        </div>

                        <div className="F12_timeline">
                            <div className='F12_timelineBar'>
                                <div className='F12_timelineFill'></div>
                                <span className='F12_timelineText'>9/16</span>
                            </div>
                        </div>

                        <div className="F12_nextFrames">
                            <div className="F12_nextFrame1"></div>
                            <div className="F12_nextFrame2"></div>
                            <div className="F12_nextFrame3"></div>
                        </div>

                    </div>

                </div>

                <div className='F12_response'>
                    <div className='F12_responseBack'>
                        <img className="F12_backIcon" onClick={() => { dispatch(pageDown()) }} src={backIcon} alt="React Logo" height={30} />
                    </div>

                    <div className={quest3.trueOptions.includes(quest3.selected) ? 'F12_responseHeadingTrue' : 'F12_responseHeadingFalse'} >
                        <p className={quest3.trueOptions.includes(quest3.selected) ? (language==='english'? 'F12_responseHeadingTextTrueEnglish' : 'F12_responseHeadingTextTrueUrdu') : (language==='english'? 'F12_responseHeadingTextFalseEnglish': 'F12_responseHeadingTextFalseUrdu')}>
                            {language === 'english' ? quest3.headingEnglish[quest3.selected] : quest3.headingUrdu[quest3.selected]}
                        </p>
                    </div>

                    <div className='F12_responseImage'>
                        <img
                            src={quest3.trueOptions.includes(quest3.selected) ? trueIcon : wrongIcon}
                            alt="React Logo"
                            height={50} />
                    </div>

                    <div className='F12_detailedResponse'>
                        {language === 'english' ?
                            <p className='F12_detailedResponseEnglish'>{quest3.contentEnglish[quest3.selected]}</p>
                            :
                            <p className='F12_detailedResponseUrdu'>{quest3.contentUrdu[quest3.selected]}</p>
                        }
                    </div>

                    <div className='F12_buttonDiv'>
                        <button onClick={() => {
                            dispatch(pageUp());
                            dispatch(set_ep1_lastVisitFrame(9))
                            if (quest3.trueOptions.includes(quest3.selected)) {
                                dispatch(scoreUp({index:2, answer: true}));
                            }
                        }}
                            className='F12_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default Frame12;